import theme from '../../services/theme'

export default {
    root: {
        primary: {
            width: '250px'
        },
        secondary: {
            width: '250px'
        }
    },
    select: {
        primary: {
            ['& fieldset']: {
                borderColor: theme.palette.SingleSelect.primary.fieldSet
            },
            ['& svg']: {
                borderColor: theme.palette.SingleSelect.primary.expander
            },
            ['&:hover']: {
                ['& fieldset']: {
                    borderColor: `${theme.palette.SingleSelect.primary.fieldSetHover} !important`
                }
            },
            background: theme.palette.SingleSelect.primary.background,
            color: theme.palette.SingleSelect.primary.color
        },
        secondary: {
            ['& fieldset']: {
                borderColor: theme.palette.SingleSelect.secondary.fieldSet
            },
            ['& svg']: {
                borderColor: theme.palette.SingleSelect.secondary.expander
            },
            ['&:hover']: {
                ['& fieldset']: {
                    borderColor: `${theme.palette.SingleSelect.secondary.fieldSetHover} !important`
                }
            },
            background: theme.palette.SingleSelect.secondary.background,
            color: theme.palette.SingleSelect.secondary.color
        }
    },
    menu: {
        primary: {
            marginTop: '10px !important'
        },
        secondary: {
            marginTop: '10px !important'
        }
    }
}